import { format, parseISO } from "date-fns";

import { DATE_FORMAT } from "@src/common/helpers/dateFormats";

export default (dateIso: string) => format(parseISO(dateIso), DATE_FORMAT);
